import React from "react";
import Loadable from "react-loadable";

import { WholePageLoader } from "@exo/loading-spinner";

const Loading = (props) => {
	if (props.error) {
		console.error("Loading Error", props.error);
		return <WholePageLoader />;
	} else {
		return <WholePageLoader />;
	}
};

// A separate setup loader per project. This sets the API endpoints.
// Loading them dynamically should theoretically be more secure

const AfricomSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/africomApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const ArlisSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/arlisApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const BalticsDemoSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/balticsDemoApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const BCBSSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/bcbsApi.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const CBPSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/cbpApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const ChinaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/chinaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const ScorpionSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/scorpionApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const NarrativeMapDemoSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/narrativeMapDemoApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const Au2024TrialSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/au2024_trialApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const DelphiSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/delphiApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const GloverSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/gloverApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const ViolinSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/violinApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const AUThunder2025SetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/auThunder2025Api.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const CAOrca2025SetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/caOrca2025Api.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const DieselSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/dieselApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const RelishSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/relishApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const Koala2022SetupLoader = Loadable.Map({
        loader: {
                SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
                api: () => import(/* webpackChunkName: "setup" */ "lib/api/koalaApi.js"),
        },
        loading: Loading,
        render(loaded, props) {
                const Setup = loaded.SetupComponent.default;
                const api = loaded.api.default;
			
                return <Setup api={api} />;
        },
});

const PnnlSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/chinaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const DcccSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/bcbsApi.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const DcosSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/dcosApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const KabulSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/kabulApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const IslamabadSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/islamabadApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const BrazilSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/brasiliaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const AatfSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/aatfApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const AfghanistanSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/afghanistandemoApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const AfghanistanDFATSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/afghanistanDFATApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const MidtermsSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/midterms.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const UsccSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/uscc23Api.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const DemoSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/demoApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const SevenTwentyLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/sevenTwenty.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const SevenTwentyUSCCLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/sevenTwenty_uscc.js"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/svg/calibrate.svg"),
		projectTheme: () => import(/* webpackChunkName: "setup" */ "config/projectVars/sevenTwenty.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		const theme = loaded.projectTheme.default;
		return <Setup api={api} customLogo={logo} projectTheme={theme} />;
	},
});

const UsipSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/usipApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const IraqSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/iraqApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const RussiaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/russiaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const OseRussiaSetupLoader = Loadable.Map({
        loader: {
                SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
                api: () => import(/* webpackChunkName: "setup" */ "lib/api/OseRussiaApi.js"),
        },
        loading: Loading,
        render(loaded, props) {
                const Setup = loaded.SetupComponent.default;
                const api = loaded.api.default;
                return <Setup api={api} />;
        },
});

const ScaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/bscaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const VenezuelaSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/venezuelaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

// Same as VenezuelaSetupLoader, except with a customLogo
const SayaraSetupLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/venezuelaApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		return <Setup api={api} />;
	},
});

const WalmartLoader = Loadable.Map({
	loader: {
		SetupComponent: () => import(/* webpackChunkName: "setup" */ "layout/Setup"),
		customLogo: () => import(/* webpackChunkName: "setup" */ "assets/images/intel471_logo.png"),
		api: () => import(/* webpackChunkName: "setup" */ "lib/api/walmartApi.js"),
	},
	loading: Loading,
	render(loaded, props) {
		const Setup = loaded.SetupComponent.default;
		const api = loaded.api.default;
		const logo = loaded.customLogo.default;
		return <Setup api={api} customLogo={logo} />;
	},
});

const SetupLoader = ({ currentProject }) => {
	return currentProject === "texas23" ? (
		<UsccSetupLoader />
	) : currentProject === "africom" ? (
		<AfricomSetupLoader />
	) : currentProject === "arlis" ? (
		<ArlisSetupLoader />
	) : currentProject === "cbp" ? (
		<CBPSetupLoader />
	) : currentProject === "balticsDemo" ? (
		<BalticsDemoSetupLoader />
	) : currentProject === "bcbs" ? (
		<BCBSSetupLoader />
	) : currentProject === "china" ? (
		<ChinaSetupLoader />
	) : currentProject === "scorpion" ? (
		<ScorpionSetupLoader />
	) : currentProject === "delphi" ? (
		<DelphiSetupLoader />
	) : currentProject === "AU_THUNDER_2025" ? (
		<AUThunder2025SetupLoader />
	) : currentProject === "CA_ORCA_2025" ? (
		<CAOrca2025SetupLoader />
	) : currentProject === "GLOVER" ? (
		<GloverSetupLoader />
	) : currentProject === "VIOLIN" ? (
		<ViolinSetupLoader />
	) : currentProject === "DIESEL" ? (
		<DieselSetupLoader />
	) : currentProject === "RELISH" ? (
		<RelishSetupLoader />
	)   : currentProject === "narrativeMapDemo" ? (
		<NarrativeMapDemoSetupLoader />
	) : currentProject === "au2024_trial" ? (
		<Au2024TrialSetupLoader />
	)  : currentProject === "pnnl" ? (
		<PnnlSetupLoader />
	) : currentProject === "dccc" ? (
		<DcccSetupLoader />
	) : currentProject === "dcos" ? (
		<DcosSetupLoader />
	) : currentProject === "iraq" ? (
		<IraqSetupLoader />
	) : currentProject === "kabul" ? (
		<KabulSetupLoader />
	) : currentProject === "islamabad" ? (
		<IslamabadSetupLoader />
	) : currentProject === "oseRussia" ? (
		<OseRussiaSetupLoader />
	) : currentProject === "brasilia" ? (
		<BrazilSetupLoader />
	) : currentProject === "aatf" ? (
		<AatfSetupLoader />
	) : currentProject === "koala" ? (
		<Koala2022SetupLoader />
	) : currentProject === "afghanistandemo" ? (
		<AfghanistanSetupLoader />
	) : currentProject === "afghanistanDFAT" ? (
		<AfghanistanDFATSetupLoader />
	) : currentProject === "usip" ? (
		<UsipSetupLoader />
	) : currentProject === "sevenTwenty" ? (
		<SevenTwentyLoader />
	) : currentProject === "sevenTwenty_uscc" ? (
		<SevenTwentyUSCCLoader />
	) : currentProject === "midterms" ? (
		<MidtermsSetupLoader />
	) : currentProject === "venezuela" ? (
		<VenezuelaSetupLoader />
	) : currentProject === "russia" ? (
		<RussiaSetupLoader />
	) : currentProject === "sayara" ? (
		<SayaraSetupLoader />
	) : currentProject === "bsca" ? (
		<ScaSetupLoader />
	) : currentProject === "walmart" ? (
		<WalmartLoader />
	) : (
		<DemoSetupLoader />
	);
};

export default SetupLoader;
